import React, { Component } from 'react';
import { Button, Icon, Card, Input } from 'semantic-ui-react';
import Server from '../../functions/server';
import $ from "jquery";
import Loading from '../loading';
import Buttons from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import DropDown from './editabledropdown';
import Delete from '@material-ui/icons/Delete';

import './style.css';

class View extends Component {

  state = {
    load: false,
    opendialog: false,
    sort: 'asc',
  }

  remove() {
    let row = this.state.deleteId;
    let context = this;
    context.setState({
      load: true,
      message: 'Remove menu controller!!!',
      opendialog: false
    });
    let id = JSON.stringify(row.ids);
    let data1 = {'id': id};
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/remove.php',
      success: function(data)
      {
        console.log(data);
        context.setState({
          load: false,
          opendialog: false
        });
        context.delete(row.id);
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  delete(id) {
    let data = this.props.data;
    let dele = [];
    data.map((del) => {
      if (del.id == id) {
        return;
      }
      else {
        dele.push(del);
      }
    });
    this.props.updatedata(dele)
  }

  removes(id) {
    if(!this.props.menuPermission.cancel) {
      alert('Access Defined!!!');
      return;
    }
    this.setState({
      opendialog: true,
      deleteId: id
    })
  }

  handleClose() {
    this.setState({
      opendialog: false
    })
  }

  sort(val) {
    let data = this.props.data;
    if (this.state.sort == 'desc') {
      data.sort(this.getSortOrderDesc(val));
      this.setState({
        data: data,
        sort: 'asc'
      })
    }
    else {
      data.sort(this.getSortOrderAsc(val));
      this.setState({
        data: data,
        sort: 'desc'
      })
    }
  }

  getSortOrderAsc(prop) {
    return function(a, b) {
      if (a[prop] > b[prop]) {
          return 1;
      } else if (a[prop] < b[prop]) {
          return -1;
      }
      return 0;
    }
  }

  getSortOrderDesc(prop) {
    return function(b, a) {
        if (a[prop] > b[prop]) {
            return 1;
        } else if (a[prop ] < b[prop]) {
            return -1;
        }
        return 0;
    }
  }

  deleteAllExecutive() {
    if(!this.props.menuPermission.cancel) {
      alert('Access Defined!!!');
      return;
    }
    let context = this;
    let executive = this.props.value;
    executive = executive.split('->')[0];
    context.setState({
      load: true,
      message: 'Deleting All Executive'
    });
    let data1 = { 'executive': executive };
    $.ajax({
      type: 'POST',
      data: data1,
      url: Server() + 'menucontrol/deleteallexecutive.php',
      success: function(data)
      {
        context.setState({
          load: false,
        });
        if (data == 1) {
          context.deleteData(executive);
        }
      },
      error: function(err)
      {
        context.setState({
          load: false,
        });
        alert('Try again!!!!')
      }
    })
  }

  deleteData(executive) {
    let oldData = this.props.data;
    let dele = [];
    oldData.map((del) => {
      if (del.executive ==  executive) {
        return;
      } else {
        dele.push(del);
      }
    });
    this.props.updatedata(dele);
  }

  render() {
    let { load, message, opendialog } = this.state;
    let loading, dialog;
    if (load) {
      loading = (<Loading load={load} message={message} />)
    }
    if (opendialog) {
    dialog = (
      <Dialog open={opendialog} onClose={this.handleClose}
          aria-labelledby="alert-dialog-title" aria-describedby="alert-dialog-description">
          <DialogTitle id="alert-dialog-title">{"Alert"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-description">
              Dont you want remove
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={this.handleClose.bind(this)} color="secondary">
              NO
            </Button>
            <Button onClick={this.remove.bind(this)} color="primary" autoFocus>
              Yes
            </Button>
          </DialogActions>
        </Dialog>
      )
    }
    let context = this;
    let i = this.props.serialNumber;
    return (
      <div>
        <div style={{paddingLeft: '85%'}}>
          <Button onClick={this.deleteAllExecutive.bind(this)}>Delete All</Button>
        </div>
      <br/>
      <div id='scrolls'>
      <table width='100%' id='table'>
          <tr id='tableheader'>
            <th style={{width: '5%', padding: '2%'}}>Id</th>
            <th onClick={this.sort.bind(this, 'name')}>Executive Name</th>
            <th onClick={this.sort.bind(this, 'menu')}>Menu Control</th>
            <th>Customer Type</th>
            <th style={{width: '7%', cursor: 'pointer'}}>Delete</th>
          </tr>
          { this.props.data.map((row) => {
              i++;
              return(
                <tr id='table_row'>
                  <td style={{width: '5%', padding: '2%'}}><center>{i}</center></td>
                  <td>{row.name}</td>
                  <td>{row.menu}</td>
                  <td style={{width: '50%'}}>
                    <DropDown menuPermission={this.props.menuPermission} row={row} editmenucontrol={this.props.editmenucontrol} data={this.props.data} />
                  </td>
                  <td onClick={this.removes.bind(this, row)} style={{width: '7%', cursor: 'pointer', display: this.props.editmenucontrol}}>
                    <center><Delete /></center>
                  </td>
                </tr>
              )
            })
          }
      </table>
      </div>
        {loading}
        {dialog}
      </div>
    );
  }
}

export default View;
